import React from 'react';
import PropTypes from 'prop-types';
import {utilsService} from '../../core/services/utils.service'

import {observer} from 'mobx-react';
import {RatingAsStars} from 'fn-common-ui';
import AppStatusIndicator from '../app-status-indicator/app-status-indicator';

@observer
export class AppRow extends React.Component {
	static propTypes = {
		app: PropTypes.object.isRequired,
		columns: PropTypes.array,
		onAppRowSelected: PropTypes.func,
		userStore: PropTypes.object
	};

	static defaultProps = {
		columns: []
	};

	get iconSrc() {
		let iconSrc = '/images/placeholder-image.png';
		if (this.props.app.icon_path) {
			iconSrc = this.props.app.icon_path;
		}
		return iconSrc
	}

	renderDate() {
		const dateColumn = this.props.columns.filter(column => {
			return column.type === 'date'
		})[0];
		//property is of the format custom_metadata.XXXX
		const propertyArray = dateColumn.property.split('.');
		const dateProperty = this.props.app[propertyArray[0]][propertyArray[1]];
		return (
			<span>
				<span className="sr-only">{dateColumn.title}</span>
				{utilsService.normalizedDate(dateProperty)}
			</span>
		);
	}

	render() {
		const showDownloadsColumn = this.props.columns.map(col => col.title).indexOf('Statistics') > -1;
		const showRatingsColumn = this.props.columns.map(col => col.title).indexOf('Ratings') > -1;
		//reassign date values so the originals aren't passed by reference in utilsService.normalizedDate;
		const releaseDate = this.props.app.custom_metadata.release_date;
		const ownApp = this.props.app.custom_metadata.developer === this.props.userStore.user.uid;		

		return (
			<tr className={ownApp ? "app-info-row" : ''} tabIndex={0} onClick={ownApp ? (e) => {
				this.props.onAppRowSelected(e, this.props.app)
			} : null} onKeyPress={(e) => { ownApp ?
				this.props.onAppRowSelected(e, this.props.app) : null
			}}>
				<th scope="row">
					<span className="sr-only">Selectable Row.</span>
					<div className="app-logo">
						<img src={this.iconSrc} alt=""/>
					</div>
					<div className="app-name">
						<div className={ownApp ? "app-name-only" : ''}>{this.props.app.app_name || "App name unavailable"}</div>
						<span className="sr-only"> Version:</span>
						<span className="lighter">{this.props.app.version.version_num || "Version unavailable"}</span>
					</div>
				</th>
				<td>
					<span className="sr-only"> For operating system:</span>
					{this.props.app.platform || 'Unavailable'}
				</td>
				<td>
					{this.renderDate()}
				</td>
				<td>
					<AppStatusIndicator status={this.props.app.custom_metadata.status} inactiveStatus={this.props.app.custom_metadata.statusReason}/>
					{this.props.app.custom_metadata.status === 'APPROVED' &&
						<p className="release-date">will go live {utilsService.normalizedDate(releaseDate)}</p>
					}
				</td>

				{showRatingsColumn &&
					<td className="no-wrap">
						<RatingAsStars rating={this.props.app.rating} />
						{this.props.app.reviews_count > 0 &&
							(
								<span className="ratings-number">
									<span>({this.props.app.reviews_count})</span>
									<span className="sr-only"> reviews</span>
								</span>
							)
						}
					</td>
				}

				{showDownloadsColumn &&
					<td>
						<span className="sr-only">statistics</span>
						<div className="view-count">
						{this.props.app.numberOfViews}
						{(this.props.app.numberOfViews != 1) ? ` views` : ` view`}
						</div>
						<div className="download-count">
						{this.props.app.download_count}
						{this.props.app.isInternalApp ? ` download${this.props.app.download_count != 1 ? 's' : ''}` : ` download intent${this.props.app.download_count != 1 ? 's' : ''}`}
						</div>
					</td>
				}

				<td>
					<span className="sr-only"> For operating system:</span>
					{`${this.props.app.custom_metadata.haloDeveloperFirstName} ${this.props.app.custom_metadata.haloDeveloperLastName}` || 'Unavailable'}
				</td>
			</tr>
		);
	}
}
